export default __webpack_public_path__ + "static/media/george.10e8d7f5.png";